const CORES_STATUS = {
  ATIVA: "completed",
  EXPIRANDO: "attention",
  EXPIRADA: "inProgress",
  REVOGADA: "pending",
  NAO_PROVISIONADA: "waitingReview",
  NUNCA_EMITIDA: "arquive",
  SEM_LICENCA: "arquive",
};

const styles = (theme) => {
  const corStatus = (status) =>
    theme.palette.chip.main[CORES_STATUS[status] || "arquive"];

  return {
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 2,
    },
    container: {
      width: "100%",
      maxWidth: "520px",
      maxHeight: "90vh",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    cabecalho: {
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between",
      gap: 2,
      padding: 2.5,
      paddingBottom: 2,
    },
    cabecalhoTextos: {
      display: "flex",
      flexDirection: "column",
      gap: "2px",
      minWidth: 0,
    },
    sobretitulo: {
      fontSize: "0.68rem",
      fontWeight: 700,
      letterSpacing: "0.14em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
    },
    titulo: {
      fontSize: "1.15rem",
      fontWeight: 700,
      lineHeight: 1.3,
      color: theme.palette.text.primary,
      overflowWrap: "anywhere",
    },
    resumo: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 1,
      marginTop: "4px",
    },
    pontoStatus: (status) => ({
      width: 8,
      height: 8,
      borderRadius: "50%",
      flexShrink: 0,
      backgroundColor: corStatus(status),
    }),
    resumoTexto: {
      fontSize: "0.75rem",
      color: theme.palette.text.secondary,
    },
    resumoSeparador: {
      fontSize: "0.75rem",
      color: theme.palette.text.disabled,
    },
    resumoId: {
      fontFamily: "monospace",
      fontSize: "0.7rem",
      color: theme.palette.text.disabled,
      overflowWrap: "anywhere",
    },
    fechar: {
      flexShrink: 0,
      borderRadius: "8px",
      color: theme.palette.text.secondary,
      border: `1px solid ${theme.palette.divider}`,
      "&:hover": {
        backgroundColor: theme.palette.background.hover,
      },
    },
    corpo: {
      display: "flex",
      flexDirection: "column",
      gap: 2.5,
      padding: 2.5,
      overflowY: "auto",
    },
    secao: {
      display: "flex",
      flexDirection: "column",
      gap: 1,
    },
    secaoTitulo: {
      fontSize: "0.65rem",
      fontWeight: 700,
      letterSpacing: "0.12em",
      textTransform: "uppercase",
      color: theme.palette.text.secondary,
    },
    botaoTestar: {
      textTransform: "none",
      fontSize: "0.75rem",
      minWidth: "auto",
      paddingInline: 1,
    },
    rodape: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 1.5,
      padding: 2,
    },
    rodapeAviso: {
      fontSize: "0.72rem",
      color: theme.palette.text.secondary,
      flex: "1 1 180px",
      minWidth: 0,
    },
    rodapeBotoes: {
      display: "flex",
      alignItems: "center",
      gap: 1,
      marginLeft: "auto",
    },
    botaoCancelar: {
      textTransform: "none",
      borderRadius: "8px",
      color: theme.palette.text.secondary,
    },
    botaoSalvar: {
      textTransform: "none",
      borderRadius: "8px",
      paddingInline: 2.5,
    },
  };
};

export default styles;
